module.exports = __webpack_public_path__ + "img/P150T_weapon_79.927e2870.png";